import i18n from '@/plugins/i18n'

export default [
    {
        path: '/' + i18n.t('routes.bill.index'),
        name: 'bill.index',
        component: () =>
            import(/* webpackChunkName: "bills" */ '@/views/bills/Index.vue'),
        meta: {
            requiresAuth: true,
            breadcrumb: [
                { text: 'Faturas', to: { name: 'bill.index' }, disable: true },
            ],
        },
    },
    {
        path: '/' + i18n.t('routes.bill.show') + '/:id',
        name: 'bill.show',
        component: () =>
            import(/* webpackChunkName: "bills" */ '@/views/bills/Show.vue'),
        meta: {
            requiresAuth: true,
            breadcrumb: [
                { text: 'Faturas', to: { name: 'bill.index' }, disable: false },
                {
                    text: 'Visualizar',
                    to: { name: 'bill.show' },
                    disable: true,
                },
            ],
        },
        props: true,
    },
    {
        path: '/bills/edit/:id',
        name: 'bill.edit',
        component: () =>
            import(/* webpackChunkName: "bills" */ '@/views/bills/Edit.vue'),
        meta: {
            requiresAuth: true,
            breadcrumb: [
                {
                    text: 'Faturas',
                    to: { name: 'bill.index' },
                    disable: false,
                },
                {
                    text: 'Editar',
                    to: { name: 'bill.edit' },
                    disable: true,
                },
            ],
        },
        props: true,
    },
]
